module.exports = __webpack_public_path__ + "static/img/IMG_20160611_123712.e2d4fa57.jpg";